import React from 'react';
import { UnstyledButton } from '@mantine/core';
import type { OrderPrintLogView } from '../../../../../services/orders/orders.service';
import { getKindLabel } from './order-print-log.utils';
import classes from './order-print-log-modal.module.scss';

type OrderPrintLogItemsModalProps = {
  log: OrderPrintLogView | null;
  onClose: () => void;
};

const OrderPrintLogItemsModalComponent: React.FC<OrderPrintLogItemsModalProps> = ({ log, onClose }) => {
  if (!log) return null;
  const routeLabels = new Set(log.items.map((item) => item.routeLabel).filter((value): value is string => typeof value === 'string' && value.trim().length > 0));
  const showPerItemRouteLabel = routeLabels.size > 1;

  return (
    <div className={classes.overlay} role="dialog" aria-modal="true" aria-label="מוצרים" dir="rtl" onClick={onClose}>
      <div className={classes.itemsModal} onClick={(event) => event.stopPropagation()}>
        <header className={classes.header}>
          <span className={classes.title}>מוצרים - {getKindLabel(log.kind)}</span>
          <UnstyledButton component="button" type="button" className={classes.closeBtn} onClick={onClose} aria-label="סגור" data-testid="print-log-items-close">
            ×
          </UnstyledButton>
        </header>

        <div className={classes.itemsContent}>
          <ul className={classes.itemsList}>
            {log.items.map((item, index) => (
              <li key={`${item.name}-${index}`} className={classes.itemRow}>
                <span>
                  {item.name}
                  {showPerItemRouteLabel && item.routeLabel ? (
                    <span className={classes.itemRouteLabel}> {item.routeLabel}</span>
                  ) : null}
                </span>
                <span>x{item.quantity}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export const OrderPrintLogItemsModal = React.memo(OrderPrintLogItemsModalComponent);
